import Vue from 'vue';
import './styles/global.scss';
import vuetify from './vuetify';
import './styles/element-ui.scss';
import App from './app';
import './plugin/dayjs';
import { request, sleep, setTitle } from './utils';
import './components';
import './filters';
import './mixins';
import router from './router';
import { Collection, authStore, settingsStore } from './stores';
import _ from 'lodash';
import './hotjar';
import { ACCESS_TOKEN_KEY } from '@/constants';

Vue.config.productionTip = false;
Vue.prototype.$sleep = sleep;
Vue.prototype.$request = request;
Vue.prototype.$get = _.get;
Vue.prototype.$Collection = Collection;
Vue.prototype.$authStore = authStore;
Vue.prototype.$settingsStore = settingsStore;

const { VUE_APP_CAP_HOST, VUE_APP_LOGIN_HOST } = process.env;

window.addEventListener('message', event => {
  const data = event.data || {};
  // CAP 退出登录时，FJP 也要退出登录，不然去到登录页面，又会跳转到 FJP
  if (event.origin === VUE_APP_CAP_HOST && data.type === 'logout') {
    localStorage.setItem(ACCESS_TOKEN_KEY, '');
  }
}, false);

const reg = new RegExp(`https?://${location.host}/?`);
setTitle(reg.test(VUE_APP_LOGIN_HOST) ? 'Login | AtomicMind' : 'Grow+ | AtomicMind');

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
